import React from 'react';
import './StepsList.scss'
import {Text} from "../../../index";
import {ArrowRightIcon, CloseIcon} from "../../../../image";
import {Checkbox} from 'antd';
import {UpdateOpenProfilePopup, UpdateOpenStepsList} from "../../../../redux/actions/tourActions";
import {useDispatch, useSelector} from "react-redux";
import {
    KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK,
} from "../../helpers";
import {useTranslation} from "react-i18next";
import {Loader} from "../../../../shared/features/Loader";
import {ApiStatus} from "../../../../utils/constants";
import {useTourActions} from "../../hooks";

const StepsList = ({successSteps, count}) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();
    const channels = useSelector(state => state.channels?.channels || []);
    const isFetchingVideos = useSelector(state => state.videos.isFetchingVideos);
    const isCheckDisabledStepTwo = !channels.some((item) => item.videos_count > 0);
    const {
        handleClickNextStep1List,
        handleClickNextStep2List,
        handleClickNextStep3List,
        handleClickNextStep4List,
        handleClickNextStep5List,
        handleClickNextStep6List
    } = useTourActions();

    const onHandleClickDontShow = () => {
        localStorage.setItem(KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK, true)
        window.dispatchEvent(
            new CustomEvent("localstorage-change", {
                detail: {key: KEY_LOCAL_STORAGE_DONT_SHOW_tOUR_BLOCK, value: true}
            })
        );
        document.querySelector('.menu__user-content')?.click();
        dispatch(UpdateOpenProfilePopup(true));
        dispatch(UpdateOpenStepsList(false));
    }

    const handleClickOneStep = () => {
        dispatch(UpdateOpenStepsList(false));
        window.scrollTo({
            top: 0
        })
        handleClickNextStep1List();
    }

    const handleClickTwoStep = () => {
        dispatch(UpdateOpenStepsList(false));
        handleClickNextStep2List();
    }

    const handleClickThreeStep = async () => {
        dispatch(UpdateOpenStepsList(false));
        handleClickNextStep3List();
    }

    const handleClickFourStep = async () => {
        dispatch(UpdateOpenStepsList(false));
        handleClickNextStep4List();
    }

    const handleClickFiveStep = async () => {
        dispatch(UpdateOpenStepsList(false));
        handleClickNextStep5List();
    }


    const handleClickSixStep = async () => {
        dispatch(UpdateOpenStepsList(false));
        handleClickNextStep6List();
    }

    return (
        <div className='steps-list'>
            <div className='steps-list__header'>
                <Text size="f16" font="book">{t('get_started')} ({count}/6)</Text>
                <CloseIcon onClick={() => dispatch(UpdateOpenStepsList(false))}/>
            </div>
            <div className='steps-list__container'>
                <div className='steps-list__item'
                     onClick={!successSteps.KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_1 ? handleClickOneStep : null}>
                    <Checkbox checked={successSteps.KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_1}>
                        <Text size="f14" font="book">{t('tour_step_1')}</Text>
                    </Checkbox>
                    <ArrowRightIcon className='steps-list__item--icon'/>
                </div>
                <div className='steps-list__item' onClick={handleClickTwoStep}>
                    <Checkbox checked={successSteps.KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_2}
                              disabled={(isCheckDisabledStepTwo)}>
                        <Text size="f14" font="book">{t('tour_step_2')}</Text>
                    </Checkbox>
                    {!isCheckDisabledStepTwo ?
                        <>
                            {isFetchingVideos === ApiStatus.LOADING ? <Loader size={20}/> :
                                <ArrowRightIcon className='steps-list__item--icon'/>}
                        </>
                        :
                        null
                    }
                </div>
                <div className='steps-list__item' onClick={handleClickThreeStep}>
                    <Checkbox checked={successSteps.KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_3}
                              disabled={(isCheckDisabledStepTwo)}>
                        <Text size="f14" font="book">{t('step_title_3')}</Text>
                    </Checkbox>
                    <ArrowRightIcon className='steps-list__item--icon'/>
                </div>
                <div className='steps-list__item' onClick={handleClickFourStep}>
                    <Checkbox checked={successSteps.KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_4}>
                        <Text size="f14" font="book">{t('step_title_4')}</Text>
                    </Checkbox>
                    <ArrowRightIcon className='steps-list__item--icon'/>
                </div>
                <div className='steps-list__item' onClick={handleClickFiveStep}>
                    <Checkbox checked={successSteps.KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_5}>
                        <Text size="f14" font="book">{t('step_title_5')}</Text>
                    </Checkbox>
                    <ArrowRightIcon className='steps-list__item--icon'/>
                </div>
                <div className='steps-list__item' onClick={handleClickSixStep}>
                    <Checkbox checked={successSteps.KEY_LOCAL_STORAGE_SUCCESS_TOUR_STEP_6}>
                        <Text size="f14" font="book">{t('step_title_6')}</Text>
                    </Checkbox>
                    <ArrowRightIcon className='steps-list__item--icon'/>
                </div>
            </div>
            <div className='steps-list__footer' onClick={onHandleClickDontShow}>
                <Text size="f16" font="book" color="#7F7F7F">{t('dont_show_this')}</Text>
            </div>
        </div>
    );
};

export default StepsList;